import { isOpenForBusiness } from "./methods/isOpenForBusiness";

export default {
  isOpenForBusiness,
};
